export const isIEBrowser = () => {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
  else return false
}
